module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic5.f00a8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic5.png
// module id = 571
// module chunks = 1